import { useCallback, useMemo, useState } from 'react';

// Id letti dall'utente: ricavati dalle views (unica fonte) più quelli segnati
// in questa sessione, finché il padre non ricarica le views dal server.
const useReadIds = (views, userId, viewKey) => {
    const [markedNow, setMarkedNow] = useState(() => new Set());

    const readIds = useMemo(() => {
        const ids = new Set((views || [])
            .filter((view) => view && view.user_id === userId)
            .map((view) => view[viewKey]));
        markedNow.forEach((id) => ids.add(id));
        return ids;
    }, [views, userId, viewKey, markedNow]);

    const addRead = useCallback((id) => setMarkedNow((prev) => new Set(prev).add(id)), []);

    return { readIds, addRead };
};

export default useReadIds;
